<div>
  <div class="mb-3">
    <span class="view-main-title">
      Información de Pre-BL
    </span>
  </div>

  <div>
    <div *ngIf="order" class="mt-3">
      <app-detail-order-card [importOrderInformation]="order" [showDetails]="true"/>
    </div>
    <div *ngIf="deliveryInformation" class="custom-tabview mt-3">
      <form [formGroup]="formGroup">
        <p-tabView>
          <p-tabPanel header="Información orden" class="tab-panel-padding">
            <div class="form-scroll">
              <h3>Importador</h3>
              <div class="p-fluid formgrid grid" *ngIf="importer">
                <div class="field col-12 md:col-4 lg:col-3">
                  <label>Nombre de contacto</label>
                  <input [ngModel]="importer.contactName" [ngModelOptions]="{standalone: true}" type="text" pInputText readonly/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label>Empresa importadora</label>
                  <input [ngModel]="importer.companyName" [ngModelOptions]="{standalone: true}" type="text" pInputText readonly/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label>VAT</label>
                  <input [ngModel]="importer.vat" [ngModelOptions]="{standalone: true}" type="text" pInputText readonly/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label>Nombre representante legal</label>
                  <input [ngModel]="importer.legalRepresentativeName" [ngModelOptions]="{standalone: true}" type="text" pInputText readonly/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label>Id representante legal</label>
                  <input [ngModel]="importer.legalRepresentativeNumber" [ngModelOptions]="{standalone: true}" type="text" pInputText readonly/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label>Email de contacto</label>
                  <input [ngModel]="importer.contactEmail" [ngModelOptions]="{standalone: true}" type="text" pInputText readonly/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label>Teléfono de contacto</label>
                  <input [ngModel]="importer.contactPhone" [ngModelOptions]="{standalone: true}" type="text" pInputText readonly/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label>Dirección de contacto</label>
                  <input [ngModel]="importer.contactAddress" [ngModelOptions]="{standalone: true}" type="text" pInputText readonly/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label>Ciudad de contacto</label>
                  <input [ngModel]="importer.contactCity" [ngModelOptions]="{standalone: true}" type="text" pInputText readonly/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label>País</label>
                  <input [ngModel]="importer.country" [ngModelOptions]="{standalone: true}" type="text" pInputText readonly/>
                </div>
              </div>
              <p-divider></p-divider>
              <h3>Detalle de orden de compra</h3>
              <div class="p-fluid formgrid grid">
                <div class="field col-12 md:col-4 lg:col-3">
                  <label>Fecha de creación</label>
                  <input [ngModel]="deliveryInformation.importOrderCreated | date: 'dd-MM-yyyy'" [ngModelOptions]="{standalone: true}" type="text" pInputText readonly/>
                </div>
              </div>
              <p-table [value]="orderDetails"
                [paginator]="true"
                [rows]="10"
                [showCurrentPageReport]="true"
                [rowsPerPageOptions]="[10, 25, 50]"
                [loading]="loading"
                responsiveLayout="stack" [breakpoint]="'960px'" [tableStyle]="{'min-width': '100%'}">
                <ng-template pTemplate="header">
                  <tr>
                    <th>
                      <div class="flex justify-content-center align-items-center">Especie / Variedad</div>
                    </th>
                    <th>
                      <div class="flex justify-content-center align-items-center">Exportador</div>
                    </th>
                    <th>
                      <div class="flex justify-content-center align-items-center">Precio unitario</div>
                    </th>
                    <th>
                      <div class="flex justify-content-center align-items-center">Cajas por pallet</div>
                    </th>
                    <th>
                      <div class="flex justify-content-center align-items-center">Pallets</div>
                    </th>
                    <th>
                      <div class="flex justify-content-center align-items-center">Cajas totales</div>
                    </th>
                    <th>
                      <div *ngIf="isCloseSale" class="flex justify-content-center align-items-center">Precio programado</div>
                      <div *ngIf="!isCloseSale" class="flex justify-content-center align-items-center">Precio total</div>
                    </th>
                    <th *ngIf="isCloseSale">
                      <div class="flex justify-content-center align-items-center">Costo fruta</div>
                    </th>
                    <th></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-orderDetail>
                  <tr>
                    <td>
                      <div class="flex justify-content-center align-items-center">{{orderDetail.speciesNameEs}} / {{orderDetail.varietyName}}</div>
                    </td>
                    <td>
                      <div class="flex justify-content-center align-items-center">{{orderDetail.exporterCompanyName}}</div>
                    </td>
                    <td>
                      <div class="flex justify-content-center align-items-center">{{orderDetail.price | currency: 'USD':'US$'}}</div>
                    </td>
                    <td>
                      <div class="flex justify-content-center align-items-center">{{orderDetail.boxesPerPallet}}</div>
                    </td>
                    <td>
                      <div class="flex justify-content-center align-items-center">{{orderDetail.palletsQuantity}}</div>
                    </td>
                    <td>
                      <div class="flex justify-content-center align-items-center">{{getDetailTotalCases(orderDetail)}}</div>
                    </td>
                    <td>
                      <div class="flex justify-content-center align-items-center">{{ getDetailTotalPrice(orderDetail) | currency:'USD':'US$' }}</div>
                    </td>
                    <td *ngIf="isCloseSale">
                      <div class="flex justify-content-center align-items-center">{{ getDetailPalletPrice(orderDetail) | currency:'USD':'US$' }}</div>
                    </td>
                    <td>
                      <div class="flex justify-content-center align-items-center">
                        <p-button label="Ver oferta" (onClick)="openExportOfferDialog(orderDetail)"></p-button>
                      </div>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
              <p-divider></p-divider>
              <h3>Consignee</h3>
              <div class="p-fluid formgrid grid">
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="consigneeCompanyName">Nombre de empresa</label>
                  <input id="consigneeCompanyName" formControlName="consigneeCompanyName" type="text" pInputText pInputText maxlength="150"/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="consigneeContactName">Nombre de contacto</label>
                  <input id="consigneeContactName" formControlName="consigneeContactName" type="text" pInputText pInputText maxlength="150"/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="consigneeVAT">VAT</label>
                  <input id="consigneeVAT" formControlName="consigneeVAT" type="text" pInputText/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="consigneeContactAddress">Dirección de contacto</label>
                  <input id="consigneeContactAddress" formControlName="consigneeContactAddress" type="text" pInputText pInputText maxlength="150"/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="consigneeContactCity">Ciudad</label>
                  <input id="consigneeContactCity" formControlName="consigneeContactCity" type="text" pInputText/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="consigneeContactCountryId">País</label>
                  <p-dropdown id="consigneeContactCountryId" formControlName="consigneeContactCountryId" [options]="countries" optionLabel="name" optionValue="id" placeholder="Selecciones un país"></p-dropdown>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="consigneeContactEmail">Email de contacto</label>
                  <input id="consigneeContactEmail" formControlName="consigneeContactEmail" type="text" pInputText pInputText maxlength="150"/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="consigneeContactPhone">Teléfono de contacto</label>
                  <input id="consigneeContactPhone" formControlName="consigneeContactPhone" type="text" pInputText/>
                </div>
              </div>
              <p-divider></p-divider>
              <h3>Notify </h3>
              <div class="p-fluid formgrid grid">
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="notifierCompanyName">Nombre de empresa</label>
                  <input id="notifierCompanyName" formControlName="notifierCompanyName" type="text" pInputText maxlength="150"/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="notifierContactName">Nombre de contacto</label>
                  <input id="notifierContactName" formControlName="notifierContactName" type="text" pInputText pInputText maxlength="150"/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="notifierVAT">VAT</label>
                  <input id="notifierVAT" formControlName="notifierVAT" type="text" pInputText/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="notifierContactAddress">Dirección de contacto</label>
                  <input id="notifierContactAddress" formControlName="notifierContactAddress" type="text" pInputText pInputText maxlength="150"/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="notifierContactCity">Ciudad</label>
                  <input id="notifierContactCity" formControlName="notifierContactCity" type="text" pInputText/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="notifierContactCountryId">País</label>
                  <p-dropdown id="notifierContactCountryId" formControlName="notifierContactCountryId" [options]="countries" optionLabel="name" optionValue="id" placeholder="Selecciones un país"></p-dropdown>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="notifierContactEmail">Email de contacto</label>
                  <input id="notifierContactEmail" formControlName="notifierContactEmail" type="text" pInputText pInputText maxlength="150"/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="notifierContactPhone">Teléfono de contacto</label>
                  <input id="notifierContactPhone" formControlName="notifierContactPhone" type="text" pInputText/>
                </div>
                <div class="col-12">
                  <p-divider></p-divider>
                </div>
                <div class="col-6"></div>
                <div class="col-6 grid">
                  <div class="col-offset-6 col-6">
                    <p-button label="Guardar" [loading]="loading" (onClick)="save()"/>
                  </div>
                </div>
              </div>
            </div>
          </p-tabPanel>
          <p-tabPanel header="Pre-BL" class="tab-panel-padding">
            <div class="form-scroll">
              <div class="flex flex-row justify-content-between align-items-center mb-3">
                <div>
                  <h3>Pre-BL</h3>
                  <div class="container-toggle">
                    <p-inputSwitch
                    [(ngModel)]="IsfFormMode"
                    (onChange)="onChangeFormMode()"
                    [ngModelOptions]="{standalone: true}"
                    styleClass="switch-large"
                    ></p-inputSwitch>
                    <h4 class="label-toggle">
                     ISF form only
                    </h4>
                  </div>
                </div>
                <div>
                    <p-button
                      label="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelButton' | translate }}"
                      icon="pi pi-upload" (click)="showDialog()"/>
                  </div>
              </div>

              <div class="p-fluid formgrid grid">
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="bl">MBL No</label>
                  <input id="bl" formControlName="mbl" type="text" pInputText/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="bl">BL No</label>
                  <input id="bl" formControlName="bl" type="text" pInputText/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="booking">Booking No</label>
                  <input id="booking" formControlName="booking" type="text" pInputText/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="containerNumber">Container N°</label>
                  <input id="containerNumber" formControlName="containerNumber" type="text" pInputText/>
                </div>
                <div class="col-12">
                  <p-divider></p-divider>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="grossWeight">Gross Weight</label>
                  <p-inputNumber
                  id="grossWeight"
                  [maxlength]="7"
                  [min]="0"
                  [useGrouping]="false"
                  [maxFractionDigits]="2"
                  locale="en-US"
                  mode="decimal"
                  formControlName="grossWeight" >
                </p-inputNumber>
                </div>
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="IsfFormMode">
                  <label for="isfCases">Cases</label>
                  <p-inputNumber
                  id="isfCases"
                  [maxlength]="7"
                  [min]="0"
                  [useGrouping]="false"
                  locale="en-US"
                  formControlName="isfCases" >
                </p-inputNumber>
                </div>
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="IsfFormMode">
                  <label for="isfPallets">Pallets</label>
                  <p-inputNumber
                  id="isfPallets"
                  [maxlength]="7"
                  [min]="0"
                  [useGrouping]="false"
                  locale="en-US"
                  formControlName="isfPallets" >
                </p-inputNumber>
                </div>
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="containerCbm">CBM</label>
                  <p-inputNumber id="containerCbm"
                    formControlName="containerCbm"
                    [min]="0"
                    [max]="100"
                    [useGrouping]="false"
                    [maxlength]="7"
                    [maxFractionDigits]="2"
                    locale="en-US"
                    mode="decimal"
                    [suffix]="'%'"
                    />
                </div>
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="containerTemperature">Temperature °C</label>
                  <p-inputNumber id="containerTemperature"
                    formControlName="containerTemperature"
                    [useGrouping]="false"
                    [maxFractionDigits]="2"
                    locale="en-US"
                    [maxlength]="10"
                    placeholder="°C"
                    mode="decimal"/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="deliveryInstructions">Instructions</label>
                  <input id="deliveryInstructions" formControlName="deliveryInstructions" type="text" pInputText/>
                </div>
                <div class="col-12">
                  <p-divider></p-divider>
                </div>
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="placeReceipt" >Place of receipt</label>
                  <input id="placeReceipt" formControlName="placeReceipt" type="text" pInputText/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="delivery?.transportType == 0">
                  <label for="departurePortId">Port of loading *</label>
                  <p-dropdown id="departurePortId" formControlName="departurePortId" [options]="ports | portName" optionLabel="fullname" optionValue="id" placeholder="Seleccione un puerto" [filter]="true" filterBy="fullname"></p-dropdown>
                  <small *ngIf="submit && formGroup.controls['departurePortId'].invalid" class="p-error">{{getErrorMessage(formGroup, 'departurePortId')}}</small>
                </div>
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="delivery?.transportType == 0">
                  <label for="destinationPortId">Port of discharge *</label>
                  <p-dropdown id="destinationPortId" formControlName="destinationPortId" [options]="ports | portName" optionLabel="fullname" optionValue="id" placeholder="Seleccione un puerto" [filter]="true" filterBy="fullname"></p-dropdown>
                  <small *ngIf="submit && formGroup.controls['destinationPortId'].invalid" class="p-error">{{getErrorMessage(formGroup, 'destinationPortId')}}</small>
                </div>
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="delivery?.transportType == 2">
                  <label for="departureCityId">City of loading</label>
                  <p-dropdown id="departureCityId" formControlName="departureCityId" [options]="cities" optionLabel="name" optionValue="id" placeholder="Seleccione una ciudad" [filter]="true" filterBy="name"></p-dropdown>
                  <small *ngIf="submit && formGroup.controls['departureCityId']?.invalid" class="p-error">{{getErrorMessage(formGroup, 'departureCityId')}}</small>
                </div>
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="delivery?.transportType == 2">
                  <label for="destinationCityId">City of discharge</label>
                  <p-dropdown id="destinationCityId" formControlName="destinationCityId" [options]="cities" optionLabel="name" optionValue="id" placeholder="Seleccione una ciudad" [filter]="true" filterBy="name"></p-dropdown>
                  <small *ngIf="submit && formGroup.controls['destinationCityId']?.invalid" class="p-error">{{getErrorMessage(formGroup, 'destinationCityId')}}</small>
                </div>

                <div class="field col-12 md:col-4 lg:col-3" *ngIf="delivery?.transportType == 1" >
                  <label for="departureAirportId" style="font-weight: bold;">{{ 'ForwarderPage.ForwarderDelivery.Delivery.OriginAirport' | translate }} *</label>
                  <p-dropdown id="departureAirportId" formControlName="departureAirportId" [options]="airPorts | portName" optionLabel="fullname" optionValue="id" placeholder="{{ 'ForwarderPage.ForwarderDelivery.Delivery.PortSelect' | translate }}"></p-dropdown>
                  <small *ngIf="submit && formGroup.controls['departureAirportId'].invalid" class="p-error">{{getErrorMessage(formGroup, 'departureAirportId')}}</small>
                </div>
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="delivery?.transportType == 1">
                  <label for="destinationAirportId">{{ 'ForwarderPage.ForwarderDelivery.Delivery.DestinationAirport' | translate }}</label>
                  <p-dropdown id="destinationAirportId" formControlName="destinationAirportId" [options]="airPorts | portName" optionLabel="fullname" optionValue="id" placeholder="{{ 'ForwarderPage.ForwarderDelivery.Delivery.PortSelect' | translate }}"></p-dropdown>
                  <small *ngIf="submit && formGroup.controls['destinationAirportId'].invalid" class="p-error">{{getErrorMessage(formGroup, 'destinationAirportId')}}</small>
                </div>

                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="week">Week</label>
                  <p-inputNumber id="week" formControlName="week" [useGrouping]="false" [min]="1" [max]="52" [maxlength]="5"/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="placeDelivery" >Place of delivery</label>
                  <input id="placeDelivery" formControlName="placeDelivery" type="text" pInputText/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="ship">Vessel name/Flight Number</label>
                  <input id="ship" formControlName="ship" type="text" pInputText/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="voyageNumber">Voyage</label>
                  <input id="voyageNumber" formControlName="voyageNumber" type="text" pInputText/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3"  *ngIf="!IsfFormMode">
                  <label for="typeMovement">Type of movement</label>
                  <input id="typeMovement" formControlName="typeMovement" type="text" pInputText/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="containerDeposit" >Container Deposit</label>
                  <input id="containerDeposit" formControlName="containerDeposit" type="text" pInputText/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="etd">ETD</label>
                  <p-calendar
                    inputId="etd"
                    formControlName="etd"
                    appendTo="body"
                    [showButtonBar]="true"
                    [showIcon]="true"
                    [showWeek]="true"
                    [firstDayOfWeek]="1"></p-calendar>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="eta">ETA</label>
                  <p-calendar
                    inputId="eta"
                    formControlName="eta"
                    appendTo="body"
                    [showButtonBar]="true"
                    [showIcon]="true"
                    [showWeek]="true"
                    [firstDayOfWeek]="1"></p-calendar>
                </div>
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="stackingStart">Stacking start</label>
                  <p-calendar
                    inputId="stackingStart"
                    formControlName="stackingStart"
                    appendTo="body"
                    [showButtonBar]="true"
                    [showIcon]="true"
                    [showWeek]="true"
                    [showTime]="true"
                    [firstDayOfWeek]="1"></p-calendar>
                </div>
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="stackingEnd">Stacking end</label>
                  <p-calendar
                    inputId="stackingEnd"
                    formControlName="stackingEnd"
                    appendTo="body"
                    [showButtonBar]="true"
                    [showIcon]="true"
                    [showWeek]="true"
                    [showTime]="true"
                    [firstDayOfWeek]="1"></p-calendar>
                </div>
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="dus">DUS</label>
                  <input id="dus" formControlName="dus" type="text" pInputText/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="sps">SPS</label>
                  <input id="sps" formControlName="sps" type="text" pInputText/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="cutoffDate">Cutoff date</label>
                  <p-calendar
                    inputId="cutoffDate"
                    formControlName="cutoffDate"
                    appendTo="body"
                    [showButtonBar]="true"
                    [showIcon]="true"
                    [showWeek]="true"
                    [showTime]="true"
                    [firstDayOfWeek]="1"></p-calendar>
                </div>
                <div class="field col-12 md:col-4 lg:col-3" >
                  <label for="shippingCompanyName">Shipping Company</label>
                  <input id="shippingCompanyName" formControlName="shippingCompanyName" type="text" pInputText/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="carrierName">Carrier name</label>
                  <input id="carrierName" formControlName="carrierName" type="text" pInputText/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="truckDriverName">Truck driver name</label>
                  <input id="truckDriverName" formControlName="truckDriverName" type="text" pInputText/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="departurePatentTruck">Departure license truck</label>
                  <input id="departurePatentTruck" formControlName="departurePatentTruck" type="text" pInputText/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="departurePatentCar">Departure license car</label>
                  <input id="departurePatentCar" formControlName="departurePatentCar" type="text" pInputText/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="ot">OT</label>
                  <input id="ot" formControlName="ot" type="text" pInputText/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="ref1">Ref 1</label>
                  <input id="ref1" formControlName="ref1" type="text" pInputText/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="ref2">Ref 2</label>
                  <input id="ref2" formControlName="ref2" type="text" pInputText/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="ctr">CTR</label>
                  <input id="ctr" formControlName="ctr" type="text" pInputText/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="importPurchaseOrder" >Import purchase order</label>
                  <input id="importPurchaseOrder" formControlName="importPurchaseOrder" type="text" pInputText/>
                </div>
                <div class="col-12">
                  <p-divider></p-divider>
                </div>

                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="freightPayableAt">Freight payable at</label>
                  <input id="freightPayableAt" formControlName="freightPayableAt" type="text" pInputText/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="shippedOnBoard">Shipped on board</label>
                  <p-calendar
                    inputId="shippedOnBoard"
                    formControlName="shippedOnBoard"
                    appendTo="body"
                    [showButtonBar]="true"
                    [showIcon]="true"
                    [showWeek]="true"
                    [firstDayOfWeek]="1"></p-calendar>
                </div>
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="placeIssue">Place of issue</label>
                  <input id="placeIssue" formControlName="placeIssue" type="text" pInputText/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="dateIssue">Date of issue</label>
                  <p-calendar
                    inputId="dateIssue"
                    formControlName="dateIssue"
                    appendTo="body"
                    [showButtonBar]="true"
                    [showIcon]="true"
                    [showWeek]="true"
                    [firstDayOfWeek]="1"></p-calendar>
                </div>
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="excessValueDeclaration">Excess value declaration</label>
                  <input id="excessValueDeclaration" formControlName="excessValueDeclaration" type="text" pInputText/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="seal">Seal</label>
                  <input id="seal" formControlName="seal" type="text" pInputText/>
                </div>


                <div class="col-12">
                  <p-divider></p-divider>
                </div>
                <!-- Fecha y Código de Repaletización -->
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="inputRepalletizationCode">Input Repalletization Code</label>
                  <input pInputText id="inputRepalletizationCode" type="text" formControlName="inputRepalletizationCode">
                </div>

                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="inputRepalletizationDate">Input Repalletization Date</label>
                    <p-calendar
                    inputId="inputRepalletizationDate"
                    formControlName="inputRepalletizationDate"
                    appendTo="body"
                    [showButtonBar]="true"
                    [showIcon]="true"
                    [showWeek]="true"
                    [firstDayOfWeek]="1"></p-calendar>
                </div>

                <!-- Proceso -->
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="inputToProcessCode">Input to Process Code</label>
                  <input pInputText id="inputToProcessCode" type="text" formControlName="inputToProcessCode">
                </div>

                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="inputToProcessDate">Input to Process Date</label>
                  <p-calendar
                    inputId="inputToProcessDate"
                    formControlName="inputToProcessDate"
                    appendTo="body"
                    [showButtonBar]="true"
                    [showIcon]="true"
                    [showWeek]="true"
                    [firstDayOfWeek]="1"></p-calendar>
                </div>

                <!-- Despacho -->
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="dispatchCode">Dispatch Code</label>
                  <input pInputText id="dispatchCode" type="text" formControlName="dispatchCode">
                </div>

                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="dispatchDate">Dispatch Date</label>
                  <p-calendar
                    inputId="dispatchDate"
                    formControlName="dispatchDate"
                    appendTo="body"
                    [showButtonBar]="true"
                    [showIcon]="true"
                    [showWeek]="true"
                    [showTime]="true"
                    [firstDayOfWeek]="1"></p-calendar>

                </div>

                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="dispatchType">Dispatch Type</label>
                  <input pInputText id="dispatchType" type="text" formControlName="dispatchType">
                </div>

                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="inspectionEntity">Inspection Entity</label>
                  <input pInputText id="inspectionEntity" type="text" formControlName="inspectionEntity">
                </div>

                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="dispatchInspectionType">Dispatch Inspection Type</label>
                  <input pInputText id="dispatchInspectionType" type="text" formControlName="dispatchInspectionType">
                </div>

                <!-- Instructivo -->
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="exporterInstructive">Exporter Instructive</label>
                  <input pInputText id="exporterInstructive" type="text" formControlName="exporterInstructive">
                </div>

                <!-- Conductor y Patentes -->
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="driverName">Driver Name</label>
                  <input pInputText id="driverName" type="text" formControlName="driverName">
                </div>

                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="vehiclePlate">Vehicle Plate</label>
                  <input pInputText id="vehiclePlate" type="text" formControlName="vehiclePlate">
                </div>

                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="wagonPlate">Wagon Plate</label>
                  <input pInputText id="wagonPlate" type="text" formControlName="wagonPlate">
                </div>

                <!-- Aduanas -->
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="customsCode">Customs Code</label>
                  <input pInputText id="customsCode" type="text" formControlName="customsCode">
                </div>

                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="customsName">Customs Name</label>
                  <input pInputText id="customsName" type="text" formControlName="customsName">
                </div>

                <!-- Agencia -->
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="codeShippingAgency">Shipping Agency Code</label>
                  <input pInputText id="codeShippingAgency" type="text" formControlName="codeShippingAgency">
                </div>

                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="nameShippingAgency">Shipping Agency Name</label>
                  <input pInputText id="nameShippingAgency" type="text" formControlName="nameShippingAgency">
                </div>

                <!-- Forwarder -->
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode" >
                  <label for="forwarderCode">Forwarder Code</label>
                  <input pInputText id="forwarderCode" type="text" formControlName="forwarderCode">
                </div>

                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="forwarderName">Forwarder Name</label>
                  <input pInputText id="forwarderName" type="text" formControlName="forwarderName">
                </div>

                <!-- Shipper -->
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="shipperCode">Shipper Code</label>
                  <input pInputText id="shipperCode" type="text" formControlName="shipperCode">
                </div>

                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="shipperName">Shipper Name</label>
                  <input pInputText id="shipperName" type="text" formControlName="shipperName">
                </div>

                <!-- Exportador -->
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="exporterCode">Exporter Code</label>
                  <input pInputText id="exporterCode" type="text" formControlName="exporterCode">
                </div>

                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="exporterName">Exporter Name</label>
                  <input pInputText id="exporterName" type="text" formControlName="exporterName">
                </div>

                <!-- Planta destino -->
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="destinationPlantCode">Destination Plant Code</label>
                  <input pInputText id="destinationPlantCode" type="text" formControlName="destinationPlantCode">
                </div>

                <!-- Hatch -->
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="hatch">Hatch</label>
                  <input pInputText id="hatch" type="text" formControlName="hatch">
                </div>

                <!-- Receiver -->
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="receiverCode">Receiver Code</label>
                  <input pInputText id="receiverCode" type="text" formControlName="receiverCode">
                </div>

                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="receiverName">Receiver Name</label>
                  <input pInputText id="receiverName" type="text" formControlName="receiverName">
                </div>

                <!-- Consignee -->
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="consigneeCode">Consignee Code</label>
                  <input pInputText id="consigneeCode" type="text" formControlName="consigneeCode">
                </div>

                <!-- Navegación -->
                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="vesselCode">Vessel Code</label>
                  <input pInputText id="vesselCode" type="text" formControlName="vesselCode">
                </div>

                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="transportTypeCode">Transport Type Code</label>
                  <input pInputText id="transportTypeCode" type="text" formControlName="transportTypeCode">
                </div>

                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="vesselType">Vessel Type</label>
                  <input pInputText id="vesselType" type="text" formControlName="vesselType">
                </div>

                <!-- Puerto de salida -->
                <!-- <div class="field col-12 md:col-4 lg:col-3">
                  <label for="departurePortCode">Departure Port Code</label>
                  <input pInputText id="departurePortCode" type="text" formControlName="departurePortCode">
                </div>

                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="departurePortName">Departure Port Name</label>
                  <input pInputText id="departurePortName" type="text" formControlName="departurePortName">
                </div> -->

                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="departureCountry">Departure Country</label>
                  <input pInputText id="departureCountry" type="text" formControlName="departureCountry">
                </div>

                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="departureWeek">Departure Week</label>
                  <input pInputText id="departureWeek" type="text" formControlName="departureWeek">
                </div>

                <!-- Puerto de arribo -->
                <!-- <div class="field col-12 md:col-4 lg:col-3">
                  <label for="arrivalPortCode">Arrival Port Code</label>
                  <input pInputText id="arrivalPortCode" type="text" formControlName="arrivalPortCode">
                </div>

                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="arrivalPort">Arrival Port</label>
                  <input pInputText id="arrivalPort" type="text" formControlName="arrivalPort">
                </div> -->

                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="arrivalCountry">Arrival Country</label>
                  <input pInputText id="arrivalCountry" type="text" formControlName="arrivalCountry">
                </div>

                <div class="field col-12 md:col-4 lg:col-3" *ngIf="!IsfFormMode">
                  <label for="arrivalContinent">Arrival Continent</label>
                  <input pInputText id="arrivalContinent" type="text" formControlName="arrivalContinent">
                </div>

                <div class="col-12">
                  <p-divider></p-divider>
                </div>

                <div class="col-6"></div>
                <div class="col-6 grid">
                  <div class="col-offset-6 col-6">
                    <p-button label="Guardar" [loading]="loading" (onClick)="save()"/>
                  </div>
                </div>
              </div>
            </div>
          </p-tabPanel>


          <p-tabPanel header="Costos" class="tab-panel-padding">
            <div class="form-scroll">
              <h3>Costos en origen</h3>

              <div class="p-fluid formgrid grid">
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="oceanFreight">Ocean freight (USD)</label>
                  <p-inputNumber id="oceanFreight" formControlName="oceanFreight" [min]="0" mode="currency" currency="USD" locale="en-US"/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="inland">Pickup (USD)</label>
                  <p-inputNumber id="inland" formControlName="inland" [min]="0" mode="currency" currency="USD" locale="en-US"/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="localCharges">Local charges (USD)</label>
                  <p-inputNumber id="localCharges" formControlName="localCharges" [min]="0" mode="currency" currency="USD" locale="en-US"/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="customs">Customs (USD)</label>
                  <p-inputNumber id="customs" formControlName="customs" [min]="0" mode="currency" currency="USD" locale="en-US"/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="surcharge">Surcharge (USD)</label>
                  <p-inputNumber id="surcharge" formControlName="surcharge" [min]="0" mode="currency" currency="USD" locale="en-US"/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="surcharge">Handling (USD)</label>
                  <p-inputNumber id="handling" formControlName="handling" [min]="0" mode="currency" currency="USD" locale="en-US"/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="surcharge">Gate out (USD)</label>
                  <p-inputNumber id="gateOut" formControlName="gateOut" [min]="0" mode="currency" currency="USD" locale="en-US"/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="otherCosts">Others (USD)</label>
                  <p-inputNumber id="otherCosts" formControlName="otherCosts" [min]="0" mode="currency" currency="USD" locale="en-US"/>
                </div>

                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="atmControl">ATM Control (USD)</label>
                  <p-inputNumber id="atmControl" formControlName="atmControl" [min]="0" mode="currency" currency="USD" locale="en-US"/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="co2Reduction">10% Co2 Reduction (USD)</label>
                  <p-inputNumber id="co2Reduction" formControlName="co2Reduction" [min]="0" mode="currency" currency="USD" locale="en-US"/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="lowSulfurSurcharge">Low Sulfur Surcharge (USD)</label>
                  <p-inputNumber id="lowSulfurSurcharge" formControlName="lowSulfurSurcharge" [min]="0" mode="currency" currency="USD" locale="en-US"/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="advancedManifestDeclaration">Advanced Manifest Declaration (USD)</label>
                  <p-inputNumber id="advancedManifestDeclaration" formControlName="advancedManifestDeclaration" [min]="0" mode="currency" currency="USD" locale="en-US"/>
                </div>
                <div class="field col-12 md:col-4 lg:col-3">
                  <label for="bunkerAdjustmentFactor">Bunker Adjustment Factor (USD)</label>
                  <p-inputNumber id="bunkerAdjustmentFactor" formControlName="bunkerAdjustmentFactor" [min]="0" mode="currency" currency="USD" locale="en-US"/>
                </div>

                <div class="field col-12 md:col-4 lg:col-3">
                  <label>Total cost (USD)</label>
                  <p-inputNumber [ngModel]="totalStaticCosts" [ngModelOptions]="{standalone: true}"  mode="currency" currency="USD" locale="en-US" [readonly]="true"/>
                </div>

                <div class="field col-12 md:col-offset-9 md:col-3 mt-4">
                  <p-button class="w-full" label="Guardar" [loading]="loading" (onClick)="save()"/>
                </div>
              </div>

              <div class="col-12">
                <p-divider></p-divider>
              </div>

              <div class="p-fluid formgrid grid">

                <div class="col-12">
                  <app-finance-table
                    [title]="'Otros costos en origen'"
                    [locationType]="locationTypeEnum['Origen']"
                    [data]="costs.originCosts"
                    [formDirective]="costFormDirective"
                    [totalCosts]="totalCosts"
                    [totalDiscounts]="totalDiscounts"
                    (openCreate)="openCostCreateDialog($event)"
                    (openEdit)="openCostEditDialog($event)"
                    (delete)="deleteCost($event)"
                  />
                </div>

                <div class="col-12 mt-4">
                  <app-finance-table
                    [title]="'Costos en destino'"
                    [locationType]="locationTypeEnum['Destino']"
                    [data]="costs.destinationCosts"
                    [formDirective]="costFormDirective"
                    [totalCosts]="totalCosts"
                    [totalDiscounts]="totalDiscounts"
                    (openCreate)="openCostCreateDialog($event)"
                    (openEdit)="openCostEditDialog($event)"
                    (delete)="deleteCost($event)"
                  />
                </div>
              </div>
            </div>
          </p-tabPanel>

          <p-tabPanel header="Descuentos" class="tab-panel-padding">
            <div class="form-scroll">
              <div class="p-fluid formgrid grid">

                <div class="col-12">
                  <app-finance-table
                    [title]="'Descuentos en origen'"
                    [locationType]="locationTypeEnum['Origen']"
                    [data]="discounts.originDiscounts"
                    [formDirective]="discountFormDirective"
                    [totalCosts]="totalCosts"
                    [totalDiscounts]="totalDiscounts"
                    (openCreate)="openDiscountCreateDialog($event)"
                    (openEdit)="openDiscountEditDialog($event)"
                    (delete)="deleteDiscount($event)"
                  />
                </div>

                <div class="col-12 mt-4">
                  <app-finance-table
                    [title]="'Descuentos en destino'"
                    [locationType]="locationTypeEnum['Destino']"
                    [data]="discounts.destinationDiscounts"
                    [formDirective]="discountFormDirective"
                    [totalCosts]="totalCosts"
                    [totalDiscounts]="totalDiscounts"
                    (openCreate)="openDiscountCreateDialog($event)"
                    (openEdit)="openDiscountEditDialog($event)"
                    (delete)="deleteDiscount($event)"
                  />
                </div>

                <div class="col-6"></div>
              </div>
            </div>
          </p-tabPanel>
        </p-tabView>
      </form>
    </div>
  </div>
</div>



<p-dialog [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visibleOfferDetailDialog" [style]="{width: '80%'}">
  <app-export-offer-detail [offer]="selectedExportOffer" [productCertificateTypes]="selectedProductCertificateTypes" [packagingTypes]="selectedPackagingTypes"></app-export-offer-detail>
  <app-frozen-fruit-export-offer-detail [offer]="frozenFruitExportOffer"></app-frozen-fruit-export-offer-detail>
  <ng-template pTemplate="footer">
    <p-button label="Cerrar" (click)="visibleOfferDetailDialog = false"></p-button>
  </ng-template>
</p-dialog>

<p-dialog
  [header]="locationType === locationTypeEnum['Origen'] ? 'Origin discount' : 'Destination discount'"
  [(visible)]="discountDialogVisible"
  [style]="{width: '40%'}" [modal]="true">
  <form [formGroup]="discountFormGroup" #discountFormDirective="ngForm">
    <div class="p-fluid formgrid grid" style="padding: 20px;">

      <div class="field col-12">
        <label for="description" style="font-weight: bolder;">Description *</label>
        <input
          id="description"
          formControlName="description"
          type="text"
          required
          pInputText
          [maxlength]="500"
          placeholder="Description"
          class="custom-input"/>
        <small *ngIf="submitDiscount && discountFormGroup.controls['description'].invalid" class="p-error">{{getErrorMessage(discountFormGroup, 'description')}}</small>
      </div>

      <div class="field col-6">
        <label for="amount" style="font-weight: bolder;">Amount *</label>
        <p-inputNumber
          id="amount"
          formControlName="amount"
          mode="currency"
          currency="USD"
          locale="en-US"
          class="custom-input-number"/>
        <small *ngIf="submitDiscount && discountFormGroup.controls['amount'].invalid" class="p-error">{{getErrorMessage(discountFormGroup, 'amount')}}</small>
      </div>

      <div class="field col-6">
        <label for="currencyCode" style="font-weight: bolder;">Currency *</label>
        <p-dropdown
          id="currencyCode"
          [options]="currencies"
          formControlName="currencyCode"
          placeholder="Select a currency"
          appendTo="body"
          class="custom-dropdown"/>
        <small *ngIf="submitDiscount && discountFormGroup.controls['currencyCode'].invalid" class="p-error">
          {{getErrorMessage(discountFormGroup, 'currencyCode')}}
        </small>
      </div>

    </div>
  </form>
  <ng-template pTemplate="footer">
    <p-button label="Close" (onClick)="discountDialogVisible = false" styleClass="p-button-outlined" class="custom-text-button"></p-button>
    <p-button label="Save" (onClick)="saveDiscount()" [loading]="loading" class="custom-text-button"></p-button>
  </ng-template>
</p-dialog>

<p-dialog
  [header]="locationType === locationTypeEnum['Origen'] ? 'Origin cost' : 'Destination cost'"
  [(visible)]="costDialogVisible"
  [style]="{width: '40%'}" [modal]="true">
  <form [formGroup]="costFormGroup" #costFormDirective="ngForm">
    <div class="p-fluid formgrid grid" style="padding: 20px;">

      <div class="field col-12">
        <label for="description" style="font-weight: bolder;">Description *</label>
        <input
          id="description"
          formControlName="description"
          type="text"
          required
          pInputText
          [maxlength]="500"
          placeholder="Description"
          class="custom-input"/>
        <small *ngIf="submitCost && costFormGroup.controls['description'].invalid" class="p-error">
          {{getErrorMessage(costFormGroup, 'description')}}
        </small>
      </div>

      <div class="field col-6">
        <label for="amount" style="font-weight: bolder;">Amount *</label>
        <p-inputNumber
          id="amount"
          formControlName="amount"
          class="custom-input-number"/>
        <small *ngIf="submitCost && costFormGroup.controls['amount'].invalid" class="p-error">
          {{getErrorMessage(costFormGroup, 'amount')}}
        </small>
      </div>

      <div class="field col-6">
        <label for="currencyCode" style="font-weight: bolder;">Currency *</label>
        <p-dropdown
          id="currencyCode"
          [options]="currencies"
          formControlName="currencyCode"
          appendTo="body"
          placeholder="Select a currency"
          class="custom-dropdown"/>
        <small *ngIf="submitCost && costFormGroup.controls['currencyCode'].invalid" class="p-error">
          {{getErrorMessage(costFormGroup, 'currencyCode')}}
        </small>
      </div>

    </div>
  </form>
  <ng-template pTemplate="footer">
    <p-button label="Close" (onClick)="costDialogVisible = false" styleClass="p-button-outlined" class="custom-text-button"></p-button>
    <p-button label="Save" (onClick)="saveCost()" [loading]="loading" class="custom-text-button"></p-button>
  </ng-template>
</p-dialog>

<p-dialog header="{{'ModalDelivery.DialogTitle' | translate}}" [(visible)]="visible" [modal]="true" [style]="{width: '25vw'}">

  <div style="margin-bottom: 20px;">
    <p >{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.FormatExcelMessage' | translate}}.</p>
  </div>
  <div class="grid">
    <div class="col-6">
      <p-fileUpload
        #excelUploader
        mode="basic"
        [multiple]="false"
        [auto]="true"
        chooseLabel="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.LoadFileFieldPlaceholder' | translate}}"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        [maxFileSize]="1000000"
        (onSelect)="onSelectExcelFile(excelUploader)">
      </p-fileUpload>
      <p *ngIf="excelFile">{{excelFile.name}}</p>
    </div>
    <div class="field col-6">
      <p-dropdown
      id="selectSheet"
      [style]="{'height': '47px'}"
      [options]="excelSheets"
      [(ngModel)]="selectedSheet"
      [ngModelOptions]="{standalone: true}"
      placeholder="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.SheetFiedlLabel' | translate}}"
      [disabled]="!excelFile">
    </p-dropdown>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button label="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.LoadButton' | translate}}" (click)="onLoadExcel2()" [disabled]="!excelFile"></p-button>
  </ng-template>
</p-dialog>
